var _a, _b;
import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import __cjsInterop1__ from "@emotion/is-prop-valid";
import { styled, Box } from "@mui/material";
import EzTextStyle from "../EzTextStyle/EzTextStyle.es.js";
import { WarningIcon, TipIcon, SuccessIcon, MarketingIcon, InfoIcon, ErrorIcon } from "../Icons/index.es.js";
const { default: isPropValid = __cjsInterop1__ } = ((_b = (_a = __cjsInterop1__) == null ? void 0 : _a.default) == null ? void 0 : _b.__esModule) ? __cjsInterop1__.default : __cjsInterop1__;
const icons = {
  error: /* @__PURE__ */ jsx(ErrorIcon, {}),
  info: /* @__PURE__ */ jsx(InfoIcon, {}),
  marketing: /* @__PURE__ */ jsx(MarketingIcon, {}),
  success: /* @__PURE__ */ jsx(SuccessIcon, {}),
  tip: /* @__PURE__ */ jsx(TipIcon, {}),
  warning: /* @__PURE__ */ jsx(WarningIcon, {})
};
const EzAlertContainer = styled("div", {
  shouldForwardProp: isPropValid,
  name: "EzAlert"
})(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  borderRadius: theme.shape.borderRadius,
  borderWidth: 0,
  display: "inline-flex",
  position: "relative",
  padding: theme.spacing(1.5),
  paddingRight: theme.spacing(2.5),
  "& svg": {
    fill: "currentColor"
  },
  // pseudo element for the arrow
  "&::before, &::after": {
    borderWidth: "6px",
    borderStyle: "solid",
    color: "transparent",
    left: "13px",
    position: "absolute"
  }
}));
const EzAlert = forwardRef(({ arrow, tagline, headline, use = "info" }, ref) => {
  const role = use === "error" ? "alert" : "status";
  const live = use === "error" ? "assertive" : "polite";
  return /* @__PURE__ */ jsxs(EzAlertContainer, { arrow, use, role, "aria-live": live, ref, children: [
    icons[use],
    /* @__PURE__ */ jsxs(Box, { marginLeft: 1, children: [
      /* @__PURE__ */ jsx(EzTextStyle, { use: "strong", children: headline }),
      /* @__PURE__ */ jsx("div", { children: tagline })
    ] })
  ] });
});
EzAlert.displayName = "EzAlert";
export {
  EzAlert as default
};
//# sourceMappingURL=EzAlert.es.js.map
